import React, { useState, useEffect } from 'react';
import {
  LazyLoadImage,
  trackWindowScroll,
} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const HeroSection = ({ scrollPosition }) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const sectionElement = document.getElementById('hero');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsInView(entry.isIntersecting));
      },
      { threshold: 0.1 },
    );

    if (sectionElement) observer.observe(sectionElement);

    return () => {
      if (sectionElement) observer.unobserve(sectionElement);
    };
  }, []);

  const sectionStyle = {
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0)' : 'translateY(20px)',
    visibility: isInView ? 'visible' : 'hidden',
  };

  return (
    <section
      id="hero"
      className="hero section dark-background"
      style={sectionStyle}
    >
      <div className="container">
        <div className="row gy-4">
          <div
            className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center"
            data-aos="fade-in"
          >
            <h1>SIMANAP</h1>
            <p>Sistem Informasi Manajemen dan Administrasi Pelayanan</p>
            <div className="d-flex">
              <a href="#about" className="btn-get-started">
                <b>Tentang Kita</b>
              </a>
            </div>
          </div>
          <div
            className="col-lg-6 order-1 order-lg-2 hero-img"
            data-aos="zoom-out"
            data-aos-delay="300"
          >
            <LazyLoadImage
              src="/img/charaSimanapDownscale1024.webp"
              srcSet="/img/charaSimanapDownscale256.webp 256w,
                      /img/charaSimanapDownscale512.webp 512w,
                      /img/charaSimanapDownscale1024.webp 1024w"
              sizes="(max-width: 768px) 100vw, 50vw"
              className="img-fluid animated"
              alt="Character SIMANAP"
              effect="blur"
              scrollPosition={scrollPosition}
              width="1024"
              height="1024"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default trackWindowScroll(HeroSection);
